import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const setupDevice = async () => {
  try {
    const response = await axios.get(
      `${Config.notificationServerUrl}/voice/generate-token?identity=browser_user`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchCallNoteAllQuestions = async (questionData) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/openai/ccm-questions`,questionData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchNewCallNoteOutreach = async (formData) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/ccm/outreach-single-response`,formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addNewCallNote = async (formData) => {
  try {
    const response = await axios.post(`${Config.patientServerUrl}/patients/create_notes`, formData,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};